<template>
  <div class="grid-y">
    <Notification v-if="error" severity="error" class="margin-bottom-xs" data-test-id="giftcard-cta-error">
      {{ error.message }}
    </Notification>

    <UpdateBag v-if="isUpdateBagEnabled" :payload="payload" :payload-validator="payloadValidator" data-test-id="update-bag" @error="errorHandler" />

    <div
      v-else
      class="cta-buttons"
      :class="{
        'desktop-inline': shoppableRedesignOptimization,
        inline: isCtaPlacementInline,
        swapped: isCtaPlacementInlineSwapped,
      }"
    >
      <AddToBag :payload="payload" :payload-validator="payloadValidator" data-test-id="add-to-bag" @error="errorHandler"> Add To Bag </AddToBag>
      <BuyNow v-if="buyNow" :payload="payload" :payload-validator="payloadValidator" data-test-id="buy-now-bottom" @error="errorHandler" />
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import Notification from '@atomic-ui/notification/Notification';

import AddToBag from '~/modules/add-to-bag/components/AddToBag';
import BuyNow from '~/modules/add-to-bag/components/BuyNow';
import UpdateBag from '~/modules/add-to-bag/components/UpdateBag';
import { useATBPayload } from '~/modules/add-to-bag/composables/useATBPayload';
import { useBagContext } from '~/modules/add-to-bag/composables/useBagContext';
import useFeatureEligibility from '~/modules/featureControl/composables/useFeatureEligibility';
import useExperiments from '~/stores/useExperimentsStore';

/**
 * @type {import('vue').Ref<Nullable<Error>>}
 */
const error = ref(null);

const props = defineProps({
  atbGiftPayload: {
    /** @type {import('vue').PropType<Partial<import('~/modules/add-to-bag/types').ATBGiftPayload>>} */
    type: Object,
    default: () => ({}),
  },
  atbGiftValidator: {
    /**
     * @type {import('vue').PropType<() => Awaitable<Nullable<string>>>}
     */
    type: Function,
    default: null,
  },
});

const { buyNow, shoppableRedesignOptimization } = useFeatureEligibility();
const { isUpdateBagEnabled } = useBagContext();
const {
  experimentFlags: { isCtaPlacementInline, isCtaPlacementInlineSwapped },
} = useExperiments();

const { payload, payloadValidator: basicPayloadValidator } = useATBPayload({
  additionalPayload: () => props.atbGiftPayload,
});

const payloadValidator = () => {
  if (typeof props.atbGiftValidator === 'function') {
    return props.atbGiftValidator();
  }
  return basicPayloadValidator();
};

/**
 * @param {Error|null|any} err
 */
const errorHandler = (err) => {
  if (err === null) {
    error.value = null;
    return;
  }
  if (err.message === 'Invalid form') {
    return;
  }
  error.value = err;
};
</script>
